import moment from 'moment'
import { schema } from 'normalizr'
import _ from 'lodash'
import store from '@/store'
export default new schema.Entity(
    'competitions',
    {},
    {
        processStrategy: competition => ({
            // Meta.
            _type: 'competition',
            _classifications: () =>
                _.filter(
                    store.getters.classifications,
                    classification =>
                        classification.competition === competition.id
                ),
            // Fields.
            ...competition,
            // Cast types.
            provisionTime: moment(competition.provisionTime),
            startedTime: moment(competition.startedTime),
            preStartedTime: competition.preStartedTime
                ? moment(competition.preStartedTime)
                : null,
        }),
    }
)
